export default __webpack_public_path__ + "static/media/radio-unselected.35f2e803.svg";